"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_common_placeholder_loader_1 = require("@hotelplan/components.common.placeholder-loader");
const DOBInputSkeleton = () => {
    return (react_1.default.createElement(components_common_placeholder_loader_1.PlaceholderLoader, { uid: "dobInputSkeleton", width: "100%", height: "50px", viewBox: '0 0 400 50', style: {
            verticalAlign: `top`,
            marginTop: '28px',
            width: '100%',
            height: '50px',
            paddingRight: '0px',
        } },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("rect", { y: "0", x: "0", height: "50", width: "100%", rx: "8" }))));
};
exports.default = DOBInputSkeleton;
//# sourceMappingURL=DOBInput.skeleton.js.map